import { Box, Grid } from "@material-ui/core";
import { width } from "@mui/system";
import { Dispatch, SetStateAction } from "react";
import { styleCollaboratorTab as style } from "../FormacionDesarrollo/css/styleSheet";
import { removeAccents } from "../../helpers/RemoveAccents";
interface Props<T> {
  initState: Array<T>;
  setState: Dispatch<SetStateAction<T[]>> | ((a: T[]) => void);
  stateInitial: Array<T>;
  label?: string;
  fields?: Array<string>;
  width?: number;
}
const SearcherTableCourse = <T extends Object>({
  initState,
  setState,
  stateInitial,
  label = "Buscar",
  width = 420,
}: Props<T>) => {
  console.log(initState);
  console.log(stateInitial);
  const handleChange = (e: any) => {
    const array = [...stateInitial];
    if (e !== "") {
      const nuevoFiltrado = array.filter((lis: any) =>
        removeAccents(lis.title.toUpperCase()).includes(
          removeAccents(e.toUpperCase())
        )
      );
      if (nuevoFiltrado.length > 0) {
        console.log("Si se encuentran datos");
        setState(nuevoFiltrado);
      } else {
        console.log("No se encuentran datos");
        console.log(nuevoFiltrado);
        setState(nuevoFiltrado);
      }
      //   console.log(nuevoFiltrado);
      //   setState(nuevoFiltrado);
    } else {
      console.log("no hay datos");
      setState(stateInitial);
    }
  };
  return (
    <Grid item>
      <Box>
        <Grid
          container
          direction="row"
          style={{ ...style.containerSearcher, width: width }}
        >
          <Grid item>
            <input
              style={{ ...style.inputSearcher, width: width - 100 }}
              className="collaboratorTab__searcher"
              placeholder={label}
              onChange={(e) => handleChange(e.target.value)}
            />
          </Grid>

          <Grid
            item
            style={{
              width: "20px",
              padding: "0 20px 0 40px",
              color: "#7f7f81",
              fontStyle: "bold",
            }}
          >
            <img src="/assets/icons/icono-buscar.svg" alt="Buscar" />
          </Grid>
        </Grid>
      </Box>
    </Grid>
  );
};

export default SearcherTableCourse;
